<div class="main-content" style="margin-top: {{margen}}">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card-header-info card-header-icon">
        <div class="card-icon">
          <i class="material-icons">inventory</i>
        </div>
        <h4 class="card-title">{{ title }}</h4>
      </div>

      <div class="card-body">

        <div class="toolbar">
          <!--        Here you can write extra buttons/actions for the toolbar              -->
        </div>

        <loading *ngIf="loading"></loading>
        <div
          *ngIf="msgerror"
          id=""
          class="alert alert-danger mt-4 d-flex align-items-center"
          role="alert"
        >
          <i style="color: white" class="material-icons"> cancel </i>
          <span>
            {{ msgerror }}
          </span>
        </div>
        <!-- div eps -->
        <div *ngIf="!loading">
          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let s of system; let i = index"
            >
              <div class="d-flex align-items-center">
                <label class="bmd-label-floating">
                  <b>System Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(s, 'system', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.serialnumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number New</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemSerialNumberNew{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.serialnumberNew"
                    [readonly]="disabled"
                  />
                </div>
                <!--[value]="
                      s.serialnumberNew !== null
                        ? s.serialnumberNew
                        : s.serialnumber
                    "-->
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">SKU</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemSKU{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.sku"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Information</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.field2"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Information</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.field3"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">PO and Line#</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="poline{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="poline"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">PO and Batch#</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batchline"
                    class="form-control fctrl"
                    [(ngModel)]="batchline"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">MDM</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="mdm{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="mdm"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Computrace</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="computrace{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="computrace"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc" *ngIf="deepSearch">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Health</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryHealth{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="batteryHealth"
                    [readonly]="true"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc" *ngIf="deepSearch">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Life</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryLife{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="batteryLife"
                    [readonly]="true"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let hdd of hdds; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>HDD #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(hdd, 'hdd', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(hdd, 'hdd')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddManufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddModel"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddSerialnumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddSerialnumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Capacity</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddCapacity{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddCapacity"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Block Size</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddBlocksize{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddBlocksize"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">RPM</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddRpm{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddRpm"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Form Factor</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddFormfactor{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddFormfactor"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Device Type</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddDevicetype{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddDevicetype"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Health Score</p>
                </div>
                <div class="col-md-6 border">
                  <!--<input type="text" name="hddHealthscore{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddHealthscore" [readonly] = "disabled">-->
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="90%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade A' ||
                      hdd.hddGrade === 'GRADE A' ||
                      hdd.hddGrade === 'Grade A-' ||
                      hdd.hddGrade === 'GRADE A-'
                    "
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="80%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade B' ||
                      hdd.hddGrade === 'GRADE B' ||
                      hdd.hddGrade === 'Grade B-' ||
                      hdd.hddGrade === 'GRADE B-'
                    "
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="70%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade C' ||
                      hdd.hddGrade === 'GRADE C' ||
                      hdd.hddGrade === 'Grade C-' ||
                      hdd.hddGrade === 'GRADE C-'
                    "
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="60%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade D' ||
                      hdd.hddGrade === 'GRADE D' ||
                      hdd.hddGrade === 'Grade D-' ||
                      hdd.hddGrade === 'GRADE D-'
                    "
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="1%+"
                    *ngIf="
                      hdd.hddGrade === 'Grade E' || hdd.hddGrade === 'GRADE E'
                    "
                  />
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="0%"
                    *ngIf="
                      hdd.hddGrade === 'Grade FAIL' ||
                      hdd.hddGrade === 'GRADE FAIL'
                    "
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Grade</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddGrade{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddGrade"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Reallocated Sectors</p>
                </div>
                <div class="col-md-6 border">
                  <!--<input type="text" name="hddReallocatedsectors{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddReallocatedsectors" [readonly] = "disabled">-->
                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="0"
                    *ngIf="
                      hdd.hddGrade === 'Grade A' ||
                      hdd.hddGrade === 'GRADE A' ||
                      hdd.hddGrade === 'Grade B' ||
                      hdd.hddGrade === 'GRADE B' ||
                      hdd.hddGrade === 'Grade C' ||
                      hdd.hddGrade === 'GRADE C' ||
                      hdd.hddGrade === 'Grade D' ||
                      hdd.hddGrade === 'GRADE D'
                    "
                  />

                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="5 MAX"
                    *ngIf="
                      hdd.hddGrade === 'Grade A-' ||
                      hdd.hddGrade === 'GRADE A-' ||
                      hdd.hddGrade === 'Grade B-' ||
                      hdd.hddGrade === 'GRADE B-' ||
                      hdd.hddGrade === 'Grade C-' ||
                      hdd.hddGrade === 'GRADE C-' ||
                      hdd.hddGrade === 'Grade D-' ||
                      hdd.hddGrade === 'GRADE D-'
                    "
                  />

                  <input
                    type="text"
                    name="hddHealthscore{{ i + 1 }}"
                    class="form-control fctrl"
                    value="50 MAX"
                    *ngIf="
                      hdd.hddGrade === 'Grade E' || hdd.hddGrade === 'GRADE E'
                    "
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Power On Hours</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddPoweronhours{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddPoweronhours"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Method</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasuremethod{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasuremethod"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Results</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasureresults{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasureresults"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.hddErasureresults === 'PASSED',
                      'color-orange': hdd.hddErasureresults === 'PARTIAL',
                      'color-red': hdd.hddErasureresults === 'FAILED',
                      'color-red-d': hdd.hddErasureresults === 'DESTROYED',
                      'color-red-r': hdd.hddErasureresults === 'REMOVED'
                    }"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure 3rd Party Verification</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hdd3rdpartyverifify{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hdd3rdpartyverifify"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.hdd3rdpartyverifify === 'PASSED',
                      'color-orange': hdd.hdd3rdpartyverifify === 'PARTIAL',
                      'color-red': hdd.hdd3rdpartyverifify === 'FAILED',
                      'color-red-d': hdd.hdd3rdpartyverifify === 'DESTROYED',
                      'color-red-r': hdd.hdd3rdpartyverifify === 'REMOVED'
                    }"
                  />
                </div>
              </div>
              <div
                class="row"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' || hdd.isDestroyed === '1'"
              >
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Results (Before)</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="statusAnterior{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.statusAnterior"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.statusAnterior === 'PASSED',
                      'color-orange': hdd.statusAnterior === 'PARTIAL',
                      'color-red': hdd.statusAnterior === 'FAILED',
                      'color-red-d': hdd.statusAnterior === 'DESTROYED',
                      'color-red-r': hdd.statusAnterior === 'REMOVED'
                    }"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Start Date</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasurestartdate{{ i + 1 }}"
                    class="form-control fctrl"
                    readonly
                    [value]="hdd.hddErasurestartdate | date : 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Start Time</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasurestarttime{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasurestarttime"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure End Date</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasureenddate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="disabled"
                    [value]="hdd.hddErasureenddate | date : 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure End Time</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasureendtime{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.hddErasureendtime"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div
                class="row"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
              >
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Destruction Date</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="destructionDate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="disabled"
                    [value]="hdd.destructionDate | date : 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div
                class="row"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
              >
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Destruction Status</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="destructionStatus{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.destructionStatus"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div
                class="row"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '1'"
              >
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Representative</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="userRemoved{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.userRemoved"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div
                class="row"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'"
              >
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Drive Removed On</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="removedDate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="disabled"
                    [value]="hdd.removedDate | date : 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div
                class="row"
                style="border-top: 1px solid #ccc"
                *ngIf="hdd.isRemoved === '1' && hdd.isDestroyed === '0'"
              >
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Representative</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="userRemoved{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.userRemoved"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <!--<div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">PO</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="hddPo{{i+1}}" class="form-control fctrl" [(ngModel)]="hdd.hddPo" [readonly] = "disabled">
                  </div>
                </div>-->
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let cpu of cpus; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>CPU #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(cpu, 'cpu', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(cpu, 'cpu')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.serialnumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Speed</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.field1"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Cores</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.field2"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Type</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.field3"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let memory of memories; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>Memory #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(memory, 'memory', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(memory, 'memory')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memorySerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.serialnumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Size</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.field1"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Speed</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.field2"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Type</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryType{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.memorytype"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let t of testing; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>Testing #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(t, 'testing', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(t, 'testing')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <!--<div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Serial Number</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="testingSerialnumber{{i+1}}" class="form-control fctrl" [(ngModel)]="t.serialnumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Profile</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="testingProfile{{i+1}}" class="form-control fctrl" [(ngModel)]="t.profile" [readonly] = "disabled">
                  </div>
                </div>-->
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">CPU</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingCPU{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.cpu"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingMemory{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.memory"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingBattery{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.battery"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Missing Parts</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.field1"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Case Condition</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.field2"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Screen Condition</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.field3"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Display Resolution</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingDisplayResolution{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.displayResolution"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Optical Device</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingOpticalDevice{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.opticalDevice"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let battery of batteries; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>Battery #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(battery, 'battery', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(battery, 'battery')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batterySerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.serialnumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Chemistry</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field1"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Capacity</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field3"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Full Charge</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField4{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field4"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Life</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField5{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.field5"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <!--<div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Battery Drain Test Results</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="batteryField7{{i+1}}" class="form-control fctrl" [(ngModel)]="battery.field7" [readonly] = "disabled">
                  </div>
                </div>-->
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let component of components; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>Component #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(component, 'component', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(component, 'component')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="componentManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="component.componentmanufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="componentModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="component.componentmodel"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="componentSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="component.componentserialnumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let network of networks; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>Network Adapter #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(network, 'network', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(network, 'network')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Adapter</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="networkAdapter{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="network.networkadapter"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let v of video; let i = index"
            >
              <div style="display: inline-block">
                <label class="bmd-label-floating">
                  <b>Video Adapter #{{ i + 1 }} Information:</b>
                </label>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="editMode()" style="margin-top: -20px;"
                >
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-primary btn-just-icon"
                  (click)="saveAttributes(v, 'video', 0)"
                  *ngIf="!disabled" style="margin-top: -20px;"
                >
                  <i class="fa fa-floppy-o" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-sm btn-link btn-danger btn-just-icon"
                  (click)="remove(v, 'video')" style="margin-top: -20px;"
                >
                  <i class="fa fa-times" aria-hidden="true"></i>
                </button>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Adapter</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="videoAdapter{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="v.videoadapter"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <!--<div class="col-md-12">
            <div class="card card-body border">

                <label class="bmd-label-floating">
                  <b>
                    Device Information:
                  </b>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="editMode()">
                    <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                  </button>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="saveAttributes()" *ngIf="!disabled" >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </label>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">System Manufacturer</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="systemManufacturer" class="form-control fctrl" [(ngModel)]="inventory.systemManufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">System Product Name</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="systemProductName" class="form-control fctrl" [(ngModel)]="inventory.systemProductName" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">System Chassis Type</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="systemChassisType" class="form-control fctrl" [(ngModel)]="inventory.systemChassisType" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">System Serial Number</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="systemSerialNumber" class="form-control fctrl" [(ngModel)]="inventory.systemSerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">PO Number</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="poNumber" class="form-control fctrl" [(ngModel)]="inventory.poNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processing Date</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processingDate" class="form-control fctrl" [(ngModel)]="inventory.processingDate" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processing Time</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processingTime" class="form-control fctrl" [(ngModel)]="inventory.processingTime" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Pxe Profile</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="pxeProfile" class="form-control fctrl" [(ngModel)]="inventory.pxeProfile" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Manufacturer</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorManufacturer" class="form-control fctrl" [(ngModel)]="inventory.processorManufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Information</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorInformation" class="form-control fctrl" [(ngModel)]="inventory.processorInformation" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Model</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorModel" class="form-control fctrl" [(ngModel)]="inventory.processorModel" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Type</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorType" class="form-control fctrl" [(ngModel)]="inventory.processorType" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Speed</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorSpeed" class="form-control fctrl" [(ngModel)]="inventory.processorSpeed" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Cores</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorCores" class="form-control fctrl" [(ngModel)]="inventory.processorCores" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Processor Serial Number</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="processorSerialNumber" class="form-control fctrl" [(ngModel)]="inventory.processorSerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Memory Manufacturer</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="memoryManufacturer" class="form-control fctrl" [(ngModel)]="inventory.memoryManufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Memory Model</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="memoryModel" class="form-control fctrl" [(ngModel)]="inventory.memoryModel" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Memory Size</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="memorySize" class="form-control fctrl" [(ngModel)]="inventory.memorySize" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Memory Information</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="memoryInformation" class="form-control fctrl" [(ngModel)]="inventory.memoryInformation" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Memory Speed</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="memorySpeed" class="form-control fctrl" [(ngModel)]="inventory.memorySpeed" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Memory Serial Number</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="memorySerialNumber" class="form-control fctrl" [(ngModel)]="inventory.memorySerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Video Adapter</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="videoAdapter" class="form-control fctrl" [(ngModel)]="inventory.videoAdapter" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Network Adapter</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="networkAdapter" class="form-control fctrl" [(ngModel)]="inventory.networkAdapter" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Optical Device</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="opticalDevice" class="form-control fctrl" [(ngModel)]="inventory.opticalDevice" [readonly] = "disabled">
                  </div>
                </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card card-body border">

                <label class="bmd-label-floating">
                  <b>
                    Drive Information:
                  </b>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="editMode()">
                    <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                  </button>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="saveAttributes()" *ngIf="!disabled" >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </label>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Manufacturer</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="Manufacturer" class="form-control fctrl" [(ngModel)]="inventory.Manufacturer" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Model</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="Model" class="form-control fctrl" [(ngModel)]="inventory.Model" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Capacity</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="Capacity" class="form-control fctrl" [(ngModel)]="inventory.Capacity" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Form Factor</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="FormFactor" class="form-control fctrl" [(ngModel)]="inventory.FormFactor" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Device Summary</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="deviceSummary" class="form-control fctrl" [(ngModel)]="inventory.deviceSummary" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Smart Power On Hours</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="smartPowerOnHours" class="form-control fctrl" [(ngModel)]="inventory.smartPowerOnHours" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Serial Number</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="SerialNumber" class="form-control fctrl" [(ngModel)]="inventory.SerialNumber" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Serial Number New</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="SerialNumber_new" class="form-control fctrl" [(ngModel)]="inventory.SerialNumber_new" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Grade</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="grade" class="form-control fctrl" [(ngModel)]="inventory.grade" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Block Size</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="BlockSize" class="form-control fctrl" [(ngModel)]="inventory.BlockSize" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">RPM</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="RPM" class="form-control fctrl" [(ngModel)]="inventory.RPM" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Health Score</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="HealthScore" class="form-control fctrl" [(ngModel)]="inventory.HealthScore" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Reallocated Sectors</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="ReallocatedSectors" class="form-control fctrl" [(ngModel)]="inventory.ReallocatedSectors" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure Summary</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureSummary" class="form-control fctrl" [(ngModel)]="inventory.erasureSummary" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure Method</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureMethod" class="form-control fctrl" [(ngModel)]="inventory.erasureMethod" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure Results</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureResults" class="form-control fctrl" [(ngModel)]="inventory.erasureResults" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure Duration</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureDuration" class="form-control fctrl" [(ngModel)]="inventory.erasureDuration" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure Start Date</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureStartDate" class="form-control fctrl" [(ngModel)]="inventory.erasureStartDate" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure Start Time</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureStartTime" class="form-control fctrl" [(ngModel)]="inventory.erasureStartTime" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure End Time</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureEndTime" class="form-control fctrl" [(ngModel)]="inventory.erasureEndTime" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Erasure End Date</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="erasureEndDate" class="form-control fctrl" [(ngModel)]="inventory.erasureEndDate" [readonly] = "disabled">
                  </div>
                </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="card card-body border">

                <label class="bmd-label-floating">
                  <b>
                    Testing Information:
                  </b>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="editMode()">
                    <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>
                  </button>
                  <button class='btn btn-sm btn-link btn-primary btn-just-icon'
                    (click)="saveAttributes()" *ngIf="!disabled" >
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                  </button>
                </label>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Battery Information</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="batteryInformation" class="form-control fctrl" [(ngModel)]="inventory.batteryInformation" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Battery Capacity</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="batteryCapacity" class="form-control fctrl" [(ngModel)]="inventory.batteryCapacity" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Battery Full Charge</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="batteryFullCharge" class="form-control fctrl" [(ngModel)]="inventory.batteryFullCharge" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Battery Life</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="batteryLife" class="form-control fctrl" [(ngModel)]="inventory.batteryLife" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Battery Grade</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="batteryGrade" class="form-control fctrl" [(ngModel)]="inventory.batteryGrade" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Burnin In Results Cpu</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="burninInResultsCpu" class="form-control fctrl" [(ngModel)]="inventory.burninInResultsCpu" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Burnin In Results Memory</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="burninInResultsMemory" class="form-control fctrl" [(ngModel)]="inventory.burninInResultsMemory" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">System Condition Grade</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="systemConditionGrade" class="form-control fctrl" [(ngModel)]="inventory.systemConditionGrade" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Missing Parts Answer 1</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="missingPartsAnswer1" class="form-control fctrl" [(ngModel)]="inventory.missingPartsAnswer1" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Physical Grading Answer 2</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="physicalGradingAnswer2" class="form-control fctrl" [(ngModel)]="inventory.physicalGradingAnswer2" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Screen Grading Answer 3</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="screenGradingAnswer3" class="form-control fctrl" [(ngModel)]="inventory.screenGradingAnswer3" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Computrace Test Results</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="computraceTestResults" class="form-control fctrl" [(ngModel)]="inventory.computraceTestResults" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Ata Gradle File</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="ataGradleFile" class="form-control fctrl" [(ngModel)]="inventory.ataGradleFile" [readonly] = "disabled">
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Scsi Gradle File</p>
                  </div>
                  <div class="col-md-6 border">
                    <input type="text" name="scsiGradleFile" class="form-control fctrl" [(ngModel)]="inventory.scsiGradleFile" [readonly] = "disabled">
                  </div>
                </div>
            </div>
          </div>-->

          <div *ngIf="!deepSearch" class="col-md-12" style="text-align: right">
            <button (click)="back()" class="btn btn-default btn-sm">
              <i class="fa fa-reply" aria-hidden="true"></i> &nbsp; Back to
              detail
            </button>
          </div>
        </div>
        <!-- end div -->
        <!-- bitraserdata -->
        <div *ngIf="bitrasershow" >
        <div *ngIf="!loading">
          
          <div class="col-md-12">
            <h5>BitRaser</h5>
            <div
              class="card card-body border"
              *ngFor="let s of raserhardware; let i = index"
            >
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.systemSerial"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">SKU</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemSKU{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.skuNumber"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Information</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.field2"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Information</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="systemField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="s.MemoryRam"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let hdd of raserdisk; let i = index"
            >
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.diskModel"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddSerialnumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.diskSerial"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Capacity</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddCapacity{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.diskSize"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Block Size</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddBlocksize{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.SectorSize"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Form Factor</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddFormfactor{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.Interface"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Device Type</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddDevicetype{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.MediaType"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Method</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasuremethod{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.erasureMethod"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Results</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasedResult{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.ErasedResult"
                    readonly
                    style="font-size: 20px; font-weight: 900"
                    [ngClass]="{
                      'color-green': hdd.ErasedResult === 'PASSED',
                      'color-orange': hdd.ErasedResult === 'PARTIAL',
                      'color-red': hdd.ErasedResult === 'FAILED',
                      'color-red-d': hdd.ErasedResult === 'DESTROYED',
                      'color-red-r': hdd.ErasedResult === 'REMOVED'
                    }"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Start Date</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasurestartdate{{ i + 1 }}"
                    class="form-control fctrl"
                    readonly
                    [value]="hdd.start | date : 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure Start Time</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasurestarttime{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.startTime"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure End Date</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasureenddate{{ i + 1 }}"
                    class="form-control fctrl"
                    [readonly]="disabled"
                    [value]="hdd.end | date : 'MM/dd/yyyy'"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Erasure End Time</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="hddErasureendtime{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="hdd.endTime"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let cpu of raserprocessor; let i = index"
            >

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.version_ModelName"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuSerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.processorID"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Speed</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.currentClockSpeed"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Processor Cores</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="cpuField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="cpu.coreEnabled"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let memory of rasermemory; let i = index"
            >

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Size</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.field1"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Speed</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryField2{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.field2"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory Type</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="memoryType{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="memory.memorytype"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let t of raserhardwaretest; let i = index"
            >

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">CPU</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingCPU{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.cpuStatus"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Memory</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingMemory{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.memoryStatus"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingBattery{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.batteryStatus"
                    [readonly]="disabled"
                  />
                </div>
              </div>

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Optical Device</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="testingOpticalDevice{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="t.opticalDriveStatus"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let battery of raserbatery; let i = index"
            >

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Manufacturer</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryManufacturer{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.manufacturer"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Model</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryModel{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Serial Number</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batterySerialNumber{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.serial"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Chemistry</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField1{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.type"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Capacity</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField3{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.current"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Full Charge</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField4{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="battery.full"
                    [readonly]="disabled"
                  />
                </div>
              </div>
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Battery Life</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="batteryField5{{ i + 1 }}"
                    class="form-control fctrl"
                    [value]="battery.health + ' %'"
                    [readonly]="disabled"
                  />
                </div>
              </div>

            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let network of rasernetwork; let i = index"
            >
              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Adapter</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="networkAdapter{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="network.model"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div
              class="card card-body border"
              *ngFor="let v of raservideo; let i = index"
            >
              

              <div class="row" style="border-top: 1px solid #ccc">
                <div class="col-md-6 bg-light border">
                  <p style="margin-top: 6px">Adapter</p>
                </div>
                <div class="col-md-6 border">
                  <input
                    type="text"
                    name="videoAdapter{{ i + 1 }}"
                    class="form-control fctrl"
                    [(ngModel)]="v.videoAdapter"
                    [readonly]="disabled"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <!-- endbitraser -->
        <div *ngIf="phonecheckshow" >
          <div *ngIf="!loading">
            
            <div class="col-md-12">
              <h5>PhoneChek</h5>
              <div class="col-md-12">
                <div
                  class="card card-body border"
                 
                >
                  <label class="bmd-label-floating">
                    <b> Mobile Information: </b>
                  </label>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Manufacturer</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemManufacturer"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.manufacturer"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemModel"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.model"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Serial Number</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSerialNumber"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.serial"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model No</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemSKU"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.modelNo"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Model #</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField2"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.modelNumber"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Memory Information</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="systemField3"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.memory"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">OS</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="os"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.oS"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">IMEI</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="iMEI"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.iMEI"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Color</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="color"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.color"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Carrier</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="carrier"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.carrier"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Country Origin</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="contryOrigin"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.contryOrigin"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Battery Health %</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="battery"
                        [value]="phonecheckinfo.battery + ' %'"
                        class="form-control fctrl"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Device Lock</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="deviceLock"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.deviceLock"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">MDM</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="mDM"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.mDM"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Grade</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="grade"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.grade"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erased</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="erased"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.erased"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Erased Type</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="erasedType"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.erasedType"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">PO#-Batch#</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="invoiceNo"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.invoiceNo"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Vendor Name</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="vendorName"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.vendorName"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                  <div class="row" style="border-top: 1px solid #ccc">
                    <div class="col-md-6 bg-light border">
                      <p style="margin-top: 6px">Tester Name</p>
                    </div>
                    <div class="col-md-6 border">
                      <input
                        type="text"
                        name="testerName"
                        class="form-control fctrl"
                        [(ngModel)]="phonecheckinfo.testerName"
                        [readonly]="disabled"
                      />
                    </div>
                  </div>
                </div>
              </div>  
            </div>
  
          <!--   <div class="col-md-12">
              <div
                class="card card-body border"
                *ngIf="phonecheckinfo"
              >
                <label class="bmd-label-floating">
                  <b> Parts: </b>
                </label>
              <div
                class="card card-body border"
                *ngFor="let v of phonecheckpart; let i = index"
              >
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Name</p>
                  </div>
                  <div class="col-md-6 border">
                    <input
                      type="text"
                      name="name"
                      class="form-control fctrl"
                      [(ngModel)]="v.name"
                      [readonly]="disabled"
                    />
                  </div>
                </div>
                <div class="row" style="border-top: 1px solid #ccc">
                  <div class="col-md-6 bg-light border">
                    <p style="margin-top: 6px">Status</p>
                  </div>
                  <div class="col-md-6 border">
                    <input
                      type="text"
                      name="Status"
                      class="form-control fctrl"
                      [(ngModel)]="v.Status"
                      [readonly]="disabled"
                    />
                  </div>
                </div>
              </div>
            </div>
            </div>  -->
            <div *ngIf="phonecheckpart?.length">
            <div class="col-md-12">
              <div class="card card-body border" *ngIf="phonecheckinfo">
                <label class="bmd-label-floating">
                  <b>Parts:</b>
                </label>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let v of phonecheckpart; let i = index">
                      <td>
                        <input
                          type="text"
                          name="name"
                          class="form-control fctrl"
                          [(ngModel)]="v.name"
                          [readonly]="disabled"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="Status"
                          class="form-control fctrl"
                          [(ngModel)]="v.Status"
                          [readonly]="disabled"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          </div>
          </div>
        <!-- endphonecheck -->
      </div>
    </div>
  </div>
</div>
